import _ from "lodash";
import Task, { waitAll } from "folktale/concurrency/task";
import Result from "folktale/result";
import { Howl } from "howler";

// {soundKey: [soundPaths]} -> Task (_ Result Error Howl)
export const loadSounds = sounds => {
  const soundKeys = _.keys(sounds);
  const soundTasks = _.map(sounds, soundPaths =>
    Task.task(resolver => {
      const sound = new Howl({
        src: soundPaths
      });

      sound.on(`load`, function() {
        !resolver.isCancelled && resolver.resolve(Result.Ok(sound));
      });

      sound.on(`loaderror`, function() {
        !resolver.isCancelled &&
          resolver.resolve(Result.Error(new Error(soundPaths)));
      });
    })
  );

  return waitAll(soundTasks).map(sounds =>
    sounds.reduce(
      (acc, sound, index) => ({
        ...acc,
        [soundKeys[index]]: sound.merge()
      }),
      {}
    )
  );
};

// {key: Howl} -> key -> undefined
export const playSoundFromSet = (howls, index) => {
  _.chain(howls)
    .omitBy(_.isError)
    .keys()
    .thru(keys => {
      if (0 === keys.length) return;

      const keyIndex = index % keys.length;
      howls[keys[keyIndex]].play();
    })
    .commit();
};
